import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppLayout } from './app/layout/component/app.layout';

import { Notfound } from './app/pages/notfound/notfound';
// import { Crud } from './app/pages/crud/crud';
import { RegisteredUserComponent } from './app/registered-user/registered-user.component';
import { LoginComponent } from './app/login/login.component';

import { ForgotPasswordComponent } from './app/forgot-password/forgot-password.component';
import { ManageRoleComponent } from './app/manage-role/manage-role.component';
import { ManageRoleGroupComponent } from './app/manage-role-group/manage-role-group.component';
import { DisplayComponent } from './app/display/display.component';
import { PreivewInvoiceComponent } from './app/preivew-invoice/preivew-invoice.component';
import { GenerateInvoiceComponent } from './app/generate-invoice/generate-invoice.component';
import { GeneratePickingListComponent } from './app/picking-list/picking-list.component';
import { PieChartComponent } from './app/pie-chart/pie-chart.component';
import { AuthGuard } from './app/auth.guard';
import { ResetPasswordComponent } from './app/reset-password/reset-password.component';
import { DashboardComponent } from './app/components/dashboard/dashboard.component';
import { ViewProfileComponent } from './app/view-profile/view-profile.component';
import { UserDashboardComponent } from './app/user-dashboard/user-dashboard.component';
import { LoginGuard } from './app/login.guard';
import { TeamComponent } from './app/team/team.component';
import { TeamDetailsComponent } from './app/team-details/team-details.component';
import { GenerateCombinePickingListComponent } from './app/generate-combine-picking-list/generate-combine-picking-list.component';
import { CustomizePickingListComponent } from './app/customize-picking-list/customize-picking-list.component';
import { CustomizeRouteWisePickinglistComponent } from './app/customize-route-wise-pickinglist/customize-route-wise-pickinglist.component';
import { AboutTornaComponent } from './app/about-torna/about-torna.component';
import { VersionHistoryComponent } from './app/version-history/version-history.component';
import { OrderdetailsComponent } from './app/orderdetails/orderdetails.component';
import { MonitoringComponent } from './app/monitoring/monitoring.component';
import { ItemDetailsV2Component } from './app/item-details-v2/item-details-v2.component';
import { DisputeReviewComponent } from './app/dispute-review/dispute-review.component';
import { DisputeReviewDetailComponent } from './app/dispute-review/dispute-review-detail.component';
import { QuotationReviewComponent } from './app/quotation-review/quotation-review.component';
import { QuotationReviewDetailComponent } from './app/quotation-review/quotation-review-detail.component';
import { CustomerPortalUsersComponent } from './app/customer-portal-users/customer-portal-users.component';
import { CustomerSupportViewComponent } from './app/customer-support-view/customer-support-view.component';
import { CustomerSupportOrderDetailComponent } from './app/customer-support-view/customer-support-order-detail.component';
import { CustomerSupportDisputeDetailComponent } from './app/customer-support-view/customer-support-dispute-detail.component';
import { PrivacyPolicyComponent } from './app/legal/privacy-policy.component';
import { TermsOfUseComponent } from './app/legal/terms-of-use.component';
import { RecommendationsAuditComponent } from './app/recommendations-audit/recommendations-audit.component';
import { ItemLastSalesComponent } from './app/item-last-sales/item-last-sales.component';

export const appRoutes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'privacy', component: PrivacyPolicyComponent },
    { path: 'terms', component: TermsOfUseComponent },

    //  { path: 'customize-picking-list', component: CustomizePickingListComponent  } ,
    { path: 'reset-password', component: ResetPasswordComponent },

    {
        path: '',
        component: AppLayout,
        canActivate: [AuthGuard], // <-- Protect all child routes
        children: [
            { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
            { path: 'recommendations-audit', component: RecommendationsAuditComponent, canActivate: [AuthGuard] },
            //  { path: '**', redirectTo: '/dashboard' },
            // { path: 'crud', component: Crud },
            { path: 'team', component: TeamComponent, canActivate: [AuthGuard] },
            { path: 'team-details/:id', component: TeamDetailsComponent, canActivate: [AuthGuard] },
            { path: 'registered-user', component: RegisteredUserComponent, canActivate: [AuthGuard] },
            { path: 'customer-portal-users', component: CustomerPortalUsersComponent, canActivate: [AuthGuard] },
            { path: 'customer-support', component: CustomerSupportViewComponent, canActivate: [AuthGuard] },
            {
                path: 'customer-support/:customerId/orders/:orderNumber',
                component: CustomerSupportOrderDetailComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'customer-support/:customerId/disputes/:claimNumber',
                component: CustomerSupportDisputeDetailComponent,
                canActivate: [AuthGuard]
            },
            { path: 'monitoring', component: MonitoringComponent, canActivate: [AuthGuard] },
            { path: 'dispute-review', component: DisputeReviewComponent, canActivate: [AuthGuard] },
            { path: 'dispute-review/:claimNumber', component: DisputeReviewDetailComponent, canActivate: [AuthGuard] },
            { path: 'quotation-review', component: QuotationReviewComponent, canActivate: [AuthGuard] },
            { path: 'quotation-review/:quotationNumber', component: QuotationReviewDetailComponent, canActivate: [AuthGuard] },
            // V1 punch UI deprecated — keep path for bookmarks; always open V2.
            {
                path: 'item/:id',
                redirectTo: ({ params }) => `item-v2/${params['id']}`,
                pathMatch: 'full'
            },
            { path: 'item-v2/:id', component: ItemDetailsV2Component, canActivate: [AuthGuard] },
            { path: 'role', component: ManageRoleComponent, canActivate: [AuthGuard] },
            { path: 'role-group', component: ManageRoleGroupComponent, canActivate: [AuthGuard] },
            { path: 'Orders', component: DisplayComponent, canActivate: [AuthGuard] },
            { path: 'Orders1', component: OrderdetailsComponent, canActivate: [AuthGuard] },
            { path: 'item-last-sales', component: ItemLastSalesComponent, canActivate: [AuthGuard] },
            { path: 'picking-list', component: GeneratePickingListComponent, canActivate: [AuthGuard] },
            { path: 'pie-chart', component: PieChartComponent, canActivate: [AuthGuard] },
            { path: 'generate-invoice', component: GenerateInvoiceComponent, canActivate: [AuthGuard] },
            { path: 'preview-invoice', component: PreivewInvoiceComponent, canActivate: [AuthGuard] },
            { path: 'combine-picking-list', component: GenerateCombinePickingListComponent, canActivate: [AuthGuard] },
            { path: 'view-profile', component: ViewProfileComponent, canActivate: [AuthGuard] },
            { path: 'user-dashboard', component: UserDashboardComponent, canActivate: [AuthGuard] },
            // { path: 'customize-picking-list', component: CustomizePickingListComponent, canActivate: [AuthGuard] },
            { path: 'about-torna', component: AboutTornaComponent, canActivate: [AuthGuard] },
            { path: 'version-history', component: VersionHistoryComponent, canActivate: [AuthGuard] },
            { path: 'customize-picking-list', component: CustomizePickingListComponent, canActivate: [AuthGuard] },
            //   {path: 'customize-route-wise-pickinglist', component: CustomizeRouteWisePickingListComponent, canActivate: [AuthGuard] },
            {
                path: 'customize-route-wise-pickinglist',
                component: CustomizeRouteWisePickinglistComponent
            }
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: '**', redirectTo: '/notfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
